/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_AchievementsInputs */

const id_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian:`)
};

const ms_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian:`)
};

const da_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements:`)
};

const de_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errungenschaften:`)
};

const en_us2_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements:`)
};

const es_es2_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros:`)
};

const es_mx2_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros:`)
};

const fil_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Achievement:`)
};

const fr_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès :`)
};

const it_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati:`)
};

const hu_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítmények:`)
};

const nl_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestaties:`)
};

const no_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasjoner:`)
};

const pl_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiągnięcia:`)
};

const pt_br2_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

const pt_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas:`)
};

const ro_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizări:`)
};

const fi_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutukset:`)
};

const sv_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestationer:`)
};

const vi_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành tích:`)
};

const tr_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarımlar:`)
};

const cs_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úspěchy:`)
};

const bg_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Постижения:`)
};

const ru_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достижения:`)
};

const uk_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Досягнення:`)
};

const ar_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإنجازات:`)
};

const hi_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धियाँ:`)
};

const th_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความสำเร็จ:`)
};

const ja_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績：`)
};

const zh_cn2_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

const zh_hant1_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

const ko_components_comparison_achievements = /** @type {(inputs: Components_Comparison_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

/**
* | output |
* | --- |
* | "Achievements:" |
*
* @param {Components_Comparison_AchievementsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_achievements = /** @type {((inputs?: Components_Comparison_AchievementsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_AchievementsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_achievements(inputs)
	if (locale === "ms") return ms_components_comparison_achievements(inputs)
	if (locale === "da") return da_components_comparison_achievements(inputs)
	if (locale === "de") return de_components_comparison_achievements(inputs)
	if (locale === "en-US") return en_us2_components_comparison_achievements(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_achievements(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_achievements(inputs)
	if (locale === "fil") return fil_components_comparison_achievements(inputs)
	if (locale === "fr") return fr_components_comparison_achievements(inputs)
	if (locale === "it") return it_components_comparison_achievements(inputs)
	if (locale === "hu") return hu_components_comparison_achievements(inputs)
	if (locale === "nl") return nl_components_comparison_achievements(inputs)
	if (locale === "no") return no_components_comparison_achievements(inputs)
	if (locale === "pl") return pl_components_comparison_achievements(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_achievements(inputs)
	if (locale === "pt") return pt_components_comparison_achievements(inputs)
	if (locale === "ro") return ro_components_comparison_achievements(inputs)
	if (locale === "fi") return fi_components_comparison_achievements(inputs)
	if (locale === "sv") return sv_components_comparison_achievements(inputs)
	if (locale === "vi") return vi_components_comparison_achievements(inputs)
	if (locale === "tr") return tr_components_comparison_achievements(inputs)
	if (locale === "cs") return cs_components_comparison_achievements(inputs)
	if (locale === "bg") return bg_components_comparison_achievements(inputs)
	if (locale === "ru") return ru_components_comparison_achievements(inputs)
	if (locale === "uk") return uk_components_comparison_achievements(inputs)
	if (locale === "ar") return ar_components_comparison_achievements(inputs)
	if (locale === "hi") return hi_components_comparison_achievements(inputs)
	if (locale === "th") return th_components_comparison_achievements(inputs)
	if (locale === "ja") return ja_components_comparison_achievements(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_achievements(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_achievements(inputs)
	return ko_components_comparison_achievements(inputs)
});
export { components_comparison_achievements as "components.comparison.achievements" }